export default {
    SET_RESULT_STEP: 'SET_RESULT_STEP',
    LOAD_DATA_TO_VUEX: 'LOAD_DATA_TO_VUEX',
    SET_ACCOUNT: 'SET_ACCOUNT',
    SET_PAYMENT: 'SET_PAYMENT',
    LOAD_PREVIEW_QUOTES: 'LOAD_PREVIEW_QUOTES'
};
